import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 → flat canonical /hvac-marketing-castle-rock
export const Route = createFileRoute("/hvac/castle-rock")({
  beforeLoad: () => {
    throw redirect({ to: "/hvac-marketing-castle-rock", statusCode: 301 });
  },
  component: () => null,
});
